"use client";
import { getLocalStorageItem, setLocalStorageItem } from "@/utils/storageUtil";
import { useEffect } from "react";

/** Render an empty componenet and uses useEffect to set the mpId to localStorage on pdp load.
 * To prevent converting pdp to a client page
 */
type Props = {
  mpId: number;
};
const SetLocalStorageComp = ({ mpId }: Props) => {
  useEffect(() => {
    const recentlyViewedItems = getLocalStorageItem("recentlyViewedItemId", []);

    const previouslyViewedIndex = recentlyViewedItems.indexOf(mpId);
    if (previouslyViewedIndex > -1) {
      recentlyViewedItems.splice(previouslyViewedIndex, 1);
    } else if (recentlyViewedItems.length >= 18) {
      recentlyViewedItems.pop();
    }
    recentlyViewedItems.unshift(mpId);
    setLocalStorageItem("recentlyViewedItemId", recentlyViewedItems);
  }, []);
  return null;
};

export default SetLocalStorageComp;
